import { useLocaleState } from 'react-admin';
import { useQuery } from 'react-query';
import { getLastClientMachineCertificate } from '../services/certificate-api.service';
import queryKeys from './query-keys';

export default function useLastClientMachineCertificate(
  clientMachineId: string
) {
  const [locale] = useLocaleState();
  return useQuery(
    queryKeys.clientMachines.lastCertificate(clientMachineId),
    () => getLastClientMachineCertificate(clientMachineId, { locale }),
    { refetchOnWindowFocus: false }
  );
}
